import React, { Component } from 'react'
import FiltroConsulta from './FiltrosConsulta';
import TabelaConsulta from './TabelaConsulta';
import { compose } from 'redux'
import { connect } from 'react-redux'
import { setAppBarValues } from '../../App/actions'
import { withNotifications } from '../../modules/notification';

import { Button } from '@material-ui/core';

import Add from '@material-ui/icons/Add';
import Print from '@material-ui/icons/Print';
import PainelEmiteRelatorio from '../../routes/sistema/OkReportDeveloper/components/PainelEmiteRelatorio';

import View from 'react-flexbox'

class ConsultaCrud extends Component {
  constructor(props) {
    super(props)
    this.state = { listaFiltrada: null }
    this.filtrou = this.filtrou.bind(this)

    this.actionsComponents = this.actionsComponents.bind(this);
  }
  componentDidMount() {
    this.props.setAppBarValues({ titulo: this.props.titulo, actions: this.actionsComponents })
  }

  actionsComponents() {
    const { classes, novo } = this.props;

    return <span style={{ minWidth: 100, display: "flex", justifyContent: "flex-end", whiteSpace: "nowrap" }}>
      {novo && <Button className={"header-botao"} variant="contained" color="secondary" onClick={novo}> <Add /><div className="responsivo-hidden">Novo</div> </Button>}
      <Button className={"header-botao"} variant="contained" color="secondary" onClick={this.dialogRelatorio.show}> <Print /><div className="responsivo-hidden">Relatórios</div> </Button>

    </span>
  }
  filtrou(listaFiltrada) {
    this.setState({ listaFiltrada })
  }

  componentWillReceiveProps(props) {
    if (this.state.listaFiltrada == null) {
      if (props.lista && props.lista.length) {
        this.filtrou(props.lista)
      }
    }
  }

  render() {
    const { titulo, colunas, lista, children, loading, novo, editar, tipoModeloRelatoriosUnico, tipoModeloRelatoriosMultipos, botoesAntes } = this.props;
    const { listaFiltrada } = this.state


    return (
      <View column style={{width:1}}>
        <FiltroConsulta titulo={titulo} filtros={children} lista={lista} filtrou={this.filtrou} />

        <TabelaConsulta
          loading={loading}
          colunas={colunas}
          lista={listaFiltrada ? listaFiltrada : []}
          editar={editar}

          tipoModeloRelatoriosUnico={tipoModeloRelatoriosUnico}
          tipoModeloRelatoriosMultipos={tipoModeloRelatoriosMultipos}
          botoesAntes={botoesAntes}
        />

        <PainelEmiteRelatorio
          ref={connectedComponent => {
            if (connectedComponent) {
              this.dialogRelatorio = connectedComponent.refs.wrappedInstance
            }
          }}
          tipoModelo={tipoModeloRelatoriosMultipos}
          dados={listaFiltrada}
        />
      </View>

    )
  }
}
const mapStateToProps = ({ }) => {


  return {};
};


export default compose(

  connect(mapStateToProps, { setAppBarValues }),
  withNotifications



)(ConsultaCrud);





// WEBPACK FOOTER //
// ./src/components/ConsultaCrud/ConsultaCrud.js